import { PropsWithChildren } from 'react';
import { cn } from '@/lib/utils';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';

interface LandingLayoutProps extends PropsWithChildren {
  className?: string;
  /** When false, the layout omits the chrome footer. The landing page does
   *  its own diary-style end-of-page and uses this to opt out. */
  showFooter?: boolean;
}

export function LandingLayout({ children, className, showFooter = true }: LandingLayoutProps) {
  return (
    <div className={cn('min-h-screen overflow-x-hidden bg-background antialiased selection:bg-primary/10', className)}>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded focus:border focus:border-foreground focus:bg-background focus:px-4 focus:py-2 focus:font-mono focus:text-sm focus:text-foreground focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-primary"
      >
        Skip to content
      </a>
      <SiteHeader />
      <main id="main" tabIndex={-1}>{children}</main>
      {showFooter && <SiteFooter />}
    </div>
  );
}
